import React, { useEffect, useState } from 'react';
import { Container, Table, Form, Button, Row, Col, Modal } from 'react-bootstrap';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/pix`;

const AdminPixManager = () => {
  const [lista, setLista] = useState([]);
  const [numero, setNumero] = useState('');
  const [nome, setNome] = useState('');
  const [editando, setEditando] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const carregarDados = async () => {
    const res = await axios.get(`${API_URL}/listar`);
    setLista(res.data);
  };

  useEffect(() => {
    carregarDados();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editando) {
        await axios.put(`${API_URL}/editar/${editando._id}`, { numero, nome });
      } else {
        await axios.post(`${API_URL}/cadastrar`, { numero, nome });
      }

      setNumero('');
      setNome('');
      setEditando(null);
      carregarDados();
    } catch (err) {
      alert('Erro ao salvar: ' + err.response?.data?.message || err.message);
    }
  };

  const handleEditar = (item) => {
    setNumero(item.numero);
    setNome(item.nome);
    setEditando(item);
  };

  const handleExcluir = async () => {
    if (!editando) return;
    await axios.delete(`${API_URL}/excluir/${editando._id}`);
    setEditando(null);
    setShowModal(false);
    carregarDados();
  };

  return (
    <Container className="mt-5">
      <h3>Gerenciar Números PIX Autorizados</h3>

      <Form onSubmit={handleSubmit} className="mt-4 mb-4">
        <Row>
          <Col md={4}>
            <Form.Control
              placeholder="Número (ex: +55 (62) 99999-9999)"
              value={numero}
              onChange={(e) => setNumero(e.target.value)}
              required
            />
          </Col>
          <Col md={4}>
            <Form.Control
              placeholder="Nome do contato"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              required
            />
          </Col>
          <Col md={4}>
            <Button variant="success" type="submit" className="w-100">
              {editando ? 'Atualizar' : 'Cadastrar'}
            </Button>
          </Col>
        </Row>
      </Form>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Número</th>
            <th>Nome</th>
            <th>Inserido em</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {lista.map((item) => (
            <tr key={item._id}>
              <td>{item.numero}</td>
              <td>{item.nome}</td>
              <td>{new Date(item.criadoEm).toLocaleString()}</td>
              <td>
                <Button variant="warning" size="sm" onClick={() => handleEditar(item)} className="me-2">
                  Editar
                </Button>
                <Button variant="danger" size="sm" onClick={() => { setEditando(item); setShowModal(true); }}>
                  Excluir
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Modal de confirmação de exclusão */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar exclusão</Modal.Title>
        </Modal.Header>
        <Modal.Body>Deseja realmente excluir o número <strong>{editando?.numero}</strong>?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleExcluir}>
            Excluir
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AdminPixManager;
